export abstract class ACCProject
{
    public id: string = '';
    public name: string = '';
    public accountId: string = '';
    public createdAt: string = '';
    public status: string = '';
    public platform: string = '';
    public jobNumber: string = '';
    public country: string = '';
}
